/* Copyright (c) 2023 Xperi. All Rights Reserved. */

export const SHOW_ANTIBURN_OSD = 'SHOW_ANTIBURN_OSD';
export const HIDE_ANTIBURN_OSD = 'HIDE_ANTIBURN_OSD';
export const UPDATE_ANTIBURN_TIMER = 'UPDATE_ANTIBURN_TIMER';
